module.exports = __webpack_public_path__ + "img/254426-1330619342.b5105ea2.jpg";